var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#AA151B",
  d: "M0 0h640v480H0z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F1BF00",
  d: "M0 120h640v240H0z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M127.3 213.3l-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2c.3-.9.9-1.2 1.4-1.5a12 12 0 011.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 002 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.3,
  d: "M127.3 213.3l-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2c.3-.9.9-1.2 1.4-1.5a12 12 0 011.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 002 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2z"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M133.8 204.5c0-.4.4-.8.8-.8s1 .4 1 .8c0 .5-.5.9-1 .9s-.8-.4-.8-.9"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M135.3 204.2v.6h-1.4v-.6h.5V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h.4"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M135.3 204.2v.6h-1.4v-.6h.5V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h.4"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M135.9 204.2v.6h-2.5v-.6h1V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h1"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M135.9 204.2v.6h-2.5v-.6h1V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h1"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M134.9 203.7c.4.1.6.4.6.8 0 .5-.4.9-.8.9s-1-.4-1-.9c0-.4.3-.7.7-.8"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M134.7 213.2H130v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1h-4.7"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M134.7 213.2H130v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1h-4.7z"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M126.8 206.8c1-.5 3 1.1 4.6 3.6m11-3.6c-.8-.5-2.8 1.1-4.5 3.6"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M127.8 215.3l-.5-1a27.3 27.3 0 0114.7 0l-.5.8a5.7 5.7 0 00-.3.8 22.9 22.9 0 00-6.6-.8c-2.6 0-5.2.3-6.5.8l-.3-.6"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M127.8 215.3l-.5-1a27.3 27.3 0 0114.7 0l-.5.8a5.7 5.7 0 00-.3.8 22.9 22.9 0 00-6.6-.8c-2.6 0-5.2.3-6.5.8l-.3-.6"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M142.1 213.2l-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 017.2-.9c3 0 5.5.4 7.4 1l.2-.6"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M142.1 213.2l-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 017.2-.9c3 0 5.5.4 7.4 1l.2-.6z"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M134.7 210.7h.2a1 1 0 000 .4c0 .6.4 1 1 1a1 1 0 001-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 00-.1.4 1 1 0 001 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 01-1.2-.6 1.6 1.6 0 01-1 .4 1.6 1.6 0 01-1.3-.6 1.6 1.6 0 01-2.4.2 1.6 1.6 0 01-1.2.6 1.5 1.5 0 01-1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 001-1 .9.9 0 000-.4v-.5l.4.4a.7.7 0 000 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 000-.3h.3"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M134.7 210.7h.2a1 1 0 000 .4c0 .6.4 1 1 1a1 1 0 001-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 00-.1.4 1 1 0 001 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 01-1.2-.6 1.6 1.6 0 01-1 .4 1.6 1.6 0 01-1.3-.6 1.6 1.6 0 01-2.4.2 1.6 1.6 0 01-1.2.6 1.5 1.5 0 01-1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 001-1 .9.9 0 000-.4v-.5l.4.4a.7.7 0 000 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 000-.3h.3z"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 017.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 00-7.4-1"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.3,
  d: "M134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 017.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 00-7.4-1z"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 01.4.4c0 .2-.2.4-.4.4a.4.4 0 01-.5-.4"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 01.4.4c0 .2-.2.4-.4.4a.4.4 0 01-.5-.4z"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 01.2.3.3.3 0 01-.3.3h-1"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 01.2.3.3.3 0 01-.3.3h-1"
});
var _ref33 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "M130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 01.2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 01-.3.4h-.7"
});
var _ref34 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 01.2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 01-.3.4h-.7"
});
var _ref35 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M127.3 215.3l.3-.4h.7l-.4.6-.6-.2"
});
var _ref36 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M127.3 215.3l.3-.4h.7l-.4.6-.6-.2"
});
var _ref37 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 01.5.4.4.4 0 01-.5.4.4.4 0 01-.4-.4"
});
var _ref38 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 01.5.4.4.4 0 01-.5.4.4.4 0 01-.4-.4z"
});
var _ref39 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "M139.3 214.9h.6a.3.3 0 00.4-.2.3.3 0 00-.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
});
var _ref40 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M139.3 214.9h.6a.3.3 0 00.4-.2.3.3 0 00-.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
});
var _ref41 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M142 215.4l-.3-.5h-.7l.3.6.6-.1"
});
var _ref42 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M142 215.4l-.3-.5h-.7l.3.6.6-.1"
});
var _ref43 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M134.6 217.1a25 25 0 01-6-.6 25.5 25.5 0 0112.1 0c-1.6.4-3.7.6-6 .6"
});
var _ref44 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.3,
  d: "M134.6 217.1a25 25 0 01-6-.6 25.5 25.5 0 0112.1 0c-1.6.4-3.7.6-6 .6z"
});
var _ref45 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M142 212l-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3"
});
var _ref46 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M142 212l-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3z"
});
var _ref47 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3"
});
var _ref48 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3z"
});
var _ref49 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M132 211.2l.1-.4c.2 0 .3.1.3.3 0 .2 0 .4-.2.4l-.2-.3"
});
var _ref50 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M132 211.2l.1-.4c.2 0 .3.1.3.3 0 .2 0 .4-.2.4l-.2-.3z"
});
var _ref51 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M127.3 212l.1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3"
});
var _ref52 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M127.3 212l.1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3z"
});
var _ref53 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M134.6 208.5l-.8.5.6 1.3.2.1.2-.1.7-1.3-.9-.5"
});
var _ref54 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M134.6 208.5l-.8.5.6 1.3.2.1.2-.1.7-1.3-.9-.5"
});
var _ref55 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M132.8 210.5l.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
});
var _ref56 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M132.8 210.5l.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
});
var _ref57 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M136.4 210.5l-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3.3.6"
});
var _ref58 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M136.4 210.5l-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3.3.6"
});
var _ref59 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M129.3 209l-.7.7.9 1 .2.1.1-.1.3-1.3-.8-.3"
});
var _ref60 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M129.3 209l-.7.7.9 1 .2.1.1-.1.3-1.3-.8-.3"
});
var _ref61 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M128 211.2l.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
});
var _ref62 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M128 211.2l.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
});
var _ref63 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M131.5 210.5l-.3.6H130l-.2-.2.1-.3 1.2-.6.5.5"
});
var _ref64 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M131.5 210.5l-.3.6H130l-.2-.2.1-.3 1.2-.6.5.5"
});
var _ref65 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
});
var _ref66 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
});
var _ref67 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 01-.5.4.5.5 0 01-.5-.4"
});
var _ref68 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 01-.5.4.5.5 0 01-.5-.4z"
});
var _ref69 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M140 209l.7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
});
var _ref70 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M140 209l.7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
});
var _ref71 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M141.4 211.2l-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
});
var _ref72 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M141.4 211.2l-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
});
var _ref73 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M137.8 210.5l.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
});
var _ref74 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M137.8 210.5l.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
});
var _ref75 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M142.5 211.4l.1.6 1.3.2.2-.1v-.2l-1-.9-.6.4"
});
var _ref76 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M142.5 211.4l.1.6 1.3.2.2-.1v-.2l-1-.9-.6.4"
});
var _ref77 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M134.2 210.4a.5.5 0 01.4-.4c.3 0 .5.2.5.4a.5.5 0 01-.5.5.5.5 0 01-.4-.5"
});
var _ref78 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M134.2 210.4a.5.5 0 01.4-.4c.3 0 .5.2.5.4a.5.5 0 01-.5.5.5.5 0 01-.4-.5z"
});
var _ref79 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 01.5.5.5.5 0 01-.5.4.5.5 0 01-.5-.4"
});
var _ref80 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 01.5.5.5.5 0 01-.5.4.5.5 0 01-.5-.4z"
});
var _ref81 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M124.8 212.2l-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 01.4.2v-.2s.3 0 .4.3v1"
});
var _ref82 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M124.8 212.2l-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 01.4.2v-.2s.3 0 .4.3v1z"
});
var _ref83 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5"
});
var _ref84 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5z"
});
var _ref85 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M144.3 212.2l.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 00-.4.2v-.2s-.3 0-.4.3v.7l.1.3"
});
var _ref86 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M144.3 212.2l.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 00-.4.2v-.2s-.3 0-.4.3v.7l.1.3z"
});
var _ref87 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5"
});
var _ref88 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z"
});
var _ref89 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M124 223h21.4v-5.5H124v5.6z"
});
var _ref90 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M124 223h21.4v-5.5H124v5.6z"
});
var _ref91 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M126.2 226.8a1 1 0 01.4 0h16.5a1.4 1.4 0 01-1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 01-.4 0h-16a1.4 1.4 0 01-.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 01-1 1.2"
});
var _ref92 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M126.2 226.8a1 1 0 01.4 0h16.5a1.4 1.4 0 01-1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 01-.4 0h-16a1.4 1.4 0 01-.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 01-1 1.2z"
});
var _ref93 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M126.6 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8"
});
var _ref94 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M126.6 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8z"
});
var _ref95 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6"
});
var _ref96 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6z"
});
var _ref97 = /*#__PURE__*/React.createElement("path", {
  fill: "#005bbf",
  d: "M149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 00-3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 01-3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 00-3.7-.8 8 8 0 00-3.7.8 8.3 8.3 0 01-3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 013.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 003.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9v-2.4"
});
var _ref98 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 00-3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 01-3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 00-3.7-.8 8 8 0 00-3.7.8 8.3 8.3 0 01-3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 013.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 003.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9v-2.4z"
});
var _ref99 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M149.6 319.8a8 8 0 01-3.7-.9 8.3 8.3 0 00-3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 00-3.7-.8 8.2 8.2 0 00-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 013.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 007.5 0 8.5 8.5 0 017.5.1 8.1 8.1 0 003.7.8v-2.3"
});
var _ref100 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M149.6 319.8a8 8 0 01-3.7-.9 8.3 8.3 0 00-3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 00-3.7-.8 8.2 8.2 0 00-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 013.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 007.5 0 8.5 8.5 0 017.5.1 8.1 8.1 0 003.7.8v-2.3"
});
var _ref101 = /*#__PURE__*/React.createElement("path", {
  fill: "#005bbf",
  d: "M149.6 322a7 7 0 01-3.7-.8 8.3 8.3 0 00-3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 00-3.7-.8 8 8 0 00-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 017.4 0 7 7 0 003.7.9 8.4 8.4 0 003.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8V322"
});
var _ref102 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M149.6 322a7 7 0 01-3.7-.8 8.3 8.3 0 00-3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 00-3.7-.8 8 8 0 00-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 017.4 0 7 7 0 003.7.9 8.4 8.4 0 003.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8V322"
});
var _ref103 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M149.6 326.7a8 8 0 01-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 00-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 01-3.7-.9 8.4 8.4 0 00-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 003.8-.9 10.2 10.2 0 017.4 0 8 8 0 003.7.9 8.4 8.4 0 003.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8v2.3"
});
var _ref104 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M149.6 326.7a8 8 0 01-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 00-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 01-3.7-.9 8.4 8.4 0 00-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 003.8-.9 10.2 10.2 0 017.4 0 8 8 0 003.7.9 8.4 8.4 0 003.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8v2.3"
});
var _ref105 = /*#__PURE__*/React.createElement("path", {
  fill: "#005bbf",
  d: "M149.6 329a8.1 8.1 0 01-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 00-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 01-3.7-.9 8.4 8.4 0 00-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 003.8-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.7.3 3.7.7a8.4 8.4 0 007.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8v2.3"
});
var _ref106 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M149.6 329a8.1 8.1 0 01-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 00-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 01-3.7-.9 8.4 8.4 0 00-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 003.8-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.7.3 3.7.7a8.4 8.4 0 007.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8v2.3z"
});
var _ref107 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M126.2 308l.2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 01-2.7-2.6v-.5a1.3 1.3 0 01-.3 0h-16a1.4 1.4 0 01-.5 0"
});
var _ref108 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M126.2 308l.2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 01-2.7-2.6v-.5a1.3 1.3 0 01-.3 0h-16a1.4 1.4 0 01-.5 0z"
});
var _ref109 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7"
});
var _ref110 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7z"
});
var _ref111 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M123.7 316.7h22V311h-22v5.6z"
});
var _ref112 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M123.7 316.7h22V311h-22v5.6z"
});
var _ref113 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 00-.1-8.8"
});
var _ref114 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 00-.1-8.8z"
});
var _ref115 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M126.8 305.6h15.6V229h-15.6v76.5z"
});
var _ref116 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M138 229.2v76.3m1.7-76.3v76.3m-12.9 0h15.6v-76.4h-15.6v76.5z"
});
var _ref117 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M158.4 257.7a49.6 49.6 0 00-23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 019.2-.7c6.6 0 12.4.8 15.8 2.1v9.4"
});
var _ref118 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M158.4 257.7a49.6 49.6 0 00-23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 019.2-.7c6.6 0 12.4.8 15.8 2.1v9.4"
});
var _ref119 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3v7.4"
});
var _ref120 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3v7.4"
});
var _ref121 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5"
});
var _ref122 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5"
});
var _ref123 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7"
});
var _ref124 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7z"
});
var _ref125 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M125.8 254c1.9-.6 3.1-1.5 2.5-3-.4-1-1.4-1-2.8-.6l-2.6 1 2.3 5.8.8-.3.8-.3-1-2.5zm-1.2-2.7l.7-.3c.5-.2 1.2.1 1.4.8.2.5.2 1-.5 1.5a4.4 4.4 0 01-.6.3l-1-2.3m7.3-2.5l-.9.3h-.8l1.3 6.1 4.3-.8-.2-.4v-.4l-2.5.6-1.2-5.3m8.4 5.2c.8-2.2 1.7-4.3 2.7-6.4a5.3 5.3 0 01-1 0 54.8 54.8 0 01-1.8 4.6l-2.4-4.3-1 .1h-1a131.4 131.4 0 013.5 6h1m8.8-4.7l.4-.9a3.4 3.4 0 00-1.7-.6c-1.7-.1-2.7.6-2.8 1.7-.2 2.1 3.2 2 3 3.4 0 .6-.7.9-1.4.8-.8 0-1.4-.5-1.4-1.2h-.3a7.3 7.3 0 01-.4 1.1 4 4 0 001.8.6c1.7.2 3-.5 3.2-1.7.2-2-3.3-2.1-3.1-3.4 0-.5.4-.8 1.3-.7.7 0 1 .4 1.2.9h.2"
});
var _ref126 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 012 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 012.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5c-.5-.1-1.2-.9-1.2-.9"
});
var _ref127 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 012 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 012.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5c-.5-.1-1.2-.9-1.2-.9z"
});
var _ref128 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9"
});
var _ref129 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9z"
});
var _ref130 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8"
});
var _ref131 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8z"
});
var _ref132 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M271 215.3a4.5 4.5 0 00-.5-1 27.4 27.4 0 0114.8 0l-.6.8a5.2 5.2 0 00-.3.8 22.9 22.9 0 00-6.6-.8c-2.6 0-5.2.3-6.6.8l-.2-.6"
});
var _ref133 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M271 215.3a4.5 4.5 0 00-.5-1 27.4 27.4 0 0114.8 0l-.6.8a5.2 5.2 0 00-.3.8 22.9 22.9 0 00-6.6-.8c-2.6 0-5.2.3-6.6.8l-.2-.6"
});
var _ref134 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 00-6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6"
});
var _ref135 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 00-6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z"
});
var _ref136 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 01-.4-.4"
});
var _ref137 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.2,
  d: "M283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 01-.4-.4zm-.2-1.4a.4.4 0 01.4-.4c.2 0 .4.1.4.4s-.2.4-.4.4a.4.4 0 01-.4-.4zm-1.1-1c0-.2.2-.3.4-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 01-.4-.5zm-1.4-.4c0-.2.2-.4.4-.4.3 0 .5.2.5.4s-.2.4-.4.4-.5-.2-.5-.4zm-1.4 0c0-.2.2-.3.5-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 01-.5-.4z"
});
var _ref138 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 0.3,
  d: "M287.8 211.2l.2-1a2.7 2.7 0 00-2.7-2.8c-.5 0-1 .1-1.3.3"
});
var _ref139 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M283 209.2l.2-.8c0-1.1-1.1-2-2.5-2-.6 0-1.2.2-1.6.4"
});
var _ref140 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.2,
  d: "M288.2 210c0-.3.2-.5.4-.5s.4.2.4.4c0 .3-.2.4-.4.4s-.4-.1-.4-.4zm-.2-1.6c0-.2.2-.4.4-.4a.4.4 0 01.5.4c0 .2-.2.4-.4.4-.3 0-.5-.2-.5-.4zm-1-1.1a.4.4 0 01.5-.4c.2 0 .4.1.4.4a.4.4 0 01-.4.4.4.4 0 01-.5-.4zm-1.3-.7c0-.2.2-.4.5-.4s.4.2.4.4c0 .3-.2.5-.4.5a.4.4 0 01-.5-.5zm-1.4.1c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4z"
});
var _ref141 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M285.3 213.2l-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 017.3-.9c2.8 0 5.4.4 7.3 1l.2-.6"
});
var _ref142 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M285.3 213.2l-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 017.3-.9c2.8 0 5.4.4 7.3 1l.2-.6z"
});
var _ref143 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 01-.4.4.4.4 0 01-.4-.4"
});
var _ref144 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.2,
  d: "M271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 01-.4.4.4.4 0 01-.4-.4zm.2-1.4c0-.3.2-.4.4-.4s.5.1.5.4-.2.4-.5.4a.4.4 0 01-.4-.4zm1-1c0-.2.3-.3.5-.3s.5.1.5.4c0 .2-.2.4-.5.4a.4.4 0 01-.4-.5zm1.4-.4c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4zm1.4 0c0-.2.2-.3.5-.3.2 0 .4.1.4.4 0 .2-.2.4-.4.4a.4.4 0 01-.5-.4z"
});
var _ref145 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 0.3,
  d: "M267.8 211.2a2.8 2.8 0 01-.2-1 2.7 2.7 0 012.7-2.8c.5 0 1 .1 1.4.3"
});
var _ref146 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M272.7 209.2a1.7 1.7 0 01-.3-.8c0-1 1.2-2 2.6-2a3 3 0 011.5.4"
});
var _ref147 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.2,
  d: "M266.6 210c0-.3.2-.5.4-.5.3 0 .4.2.4.4a.4.4 0 01-.4.4c-.2 0-.4-.1-.4-.4zm.1-1.6c0-.2.3-.4.5-.4s.4.2.4.4-.2.4-.4.4-.4-.2-.4-.4zm1-1.1c0-.3.2-.4.5-.4a.4.4 0 01.4.4.4.4 0 01-.4.4.4.4 0 01-.5-.4zm1.3-.7c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.4.4 0 01-.5-.5zm1.4.1c0-.2.2-.4.5-.4a.4.4 0 01.4.4.4.4 0 01-.4.4c-.3 0-.5-.2-.5-.4z"
});
var _ref148 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M277.9 210.7h.2a1 1 0 000 .4c0 .6.5 1 1 1a1 1 0 001-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 000-.1l.4-.4.2.5a1 1 0 00-.1.4 1 1 0 001 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 01-.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 01-1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 01-1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 01-1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2a4.2 4.2 0 01-1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 001-1 1 1 0 000-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 000-.3h.2"
});
var _ref149 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M277.9 210.7h.2a1 1 0 000 .4c0 .6.5 1 1 1a1 1 0 001-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 000-.1l.4-.4.2.5a1 1 0 00-.1.4 1 1 0 001 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 01-.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 01-1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 01-1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 01-1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2a4.2 4.2 0 01-1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 001-1 1 1 0 000-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 000-.3h.2z"
});
var _ref150 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 00-7.4-1"
});
var _ref151 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 00-7.4-1z"
});
var _ref152 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M275 214.4c0-.3.2-.4.5-.4a.4.4 0 01.4.4.4.4 0 01-.4.4c-.3 0-.5-.2-.5-.4"
});
var _ref153 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M275 214.4c0-.3.2-.4.5-.4a.4.4 0 01.4.4.4.4 0 01-.4.4c-.3 0-.5-.2-.5-.4z"
});
var _ref154 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 01.2.3.3.3 0 01-.3.3h-1"
});
var _ref155 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 01.2.3.3.3 0 01-.3.3h-1"
});
var _ref156 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "M273.2 214.9h-.6a.3.3 0 01-.4-.2.3.3 0 01.3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 01-.3.4h-.7"
});
var _ref157 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M273.2 214.9h-.6a.3.3 0 01-.4-.2.3.3 0 01.3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 01-.3.4h-.7"
});
var _ref158 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M270.5 215.3l.3-.4h.7l-.4.6-.6-.2"
});
var _ref159 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M270.5 215.3l.3-.4h.7l-.4.6-.6-.2"
});
var _ref160 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 01-.4-.4"
});
var _ref161 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 01-.4-.4z"
});
var _ref162 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "M282.5 214.9h.7a.3.3 0 00.3-.2.3.3 0 00-.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
});
var _ref163 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M282.5 214.9h.7a.3.3 0 00.3-.2.3.3 0 00-.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
});
var _ref164 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M285.1 215.4l-.2-.5h-.7l.3.6.6-.1"
});
var _ref165 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M285.1 215.4l-.2-.5h-.7l.3.6.6-.1"
});
var _ref166 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M277.8 217.1a25 25 0 01-6-.6 25.4 25.4 0 016-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6"
});
var _ref167 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.3,
  d: "M277.8 217.1a25 25 0 01-6-.6 25.4 25.4 0 016-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6z"
});
var _ref168 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M285.2 212l-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3"
});
var _ref169 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M285.2 212l-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3z"
});
var _ref170 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3"
});
var _ref171 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3z"
});
var _ref172 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3"
});
var _ref173 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3z"
});
var _ref174 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M270.5 212l.1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3"
});
var _ref175 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M270.5 212l.1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3z"
});
var _ref176 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M277.8 208.5l-.8.5.6 1.3.2.1.3-.1.6-1.3-.9-.5"
});
var _ref177 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M277.8 208.5l-.8.5.6 1.3.2.1.3-.1.6-1.3-.9-.5"
});
var _ref178 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M276 210.5l.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
});
var _ref179 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M276 210.5l.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
});
var _ref180 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M279.6 210.5l-.3.5-1.3-.4-.1-.2v-.2l1.4-.3.4.6"
});
var _ref181 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M279.6 210.5l-.3.5-1.3-.4-.1-.2v-.2l1.4-.3.4.6"
});
var _ref182 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M272.5 209l-.7.7.9 1 .2.1.2-.1.2-1.3-.8-.3"
});
var _ref183 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M272.5 209l-.7.7.9 1 .2.1.2-.1.2-1.3-.8-.3"
});
var _ref184 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M271.1 211.2l.5.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
});
var _ref185 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M271.1 211.2l.5.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
});
var _ref186 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M274.7 210.5l-.3.6h-1.3l-.2-.2.1-.3 1.2-.6.5.5"
});
var _ref187 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M274.7 210.5l-.3.6h-1.3l-.2-.2.1-.3 1.2-.6.5.5"
});
var _ref188 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
});
var _ref189 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
});
var _ref190 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 01.5.5.5.5 0 01-.5.4.5.5 0 01-.5-.4"
});
var _ref191 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 01.5.5.5.5 0 01-.5.4.5.5 0 01-.5-.4z"
});
var _ref192 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M283.2 209l.7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
});
var _ref193 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M283.2 209l.7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
});
var _ref194 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M284.6 211.2l-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
});
var _ref195 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M284.6 211.2l-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
});
var _ref196 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M281 210.5l.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
});
var _ref197 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M281 210.5l.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
});
var _ref198 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9-.6.4"
});
var _ref199 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9-.6.4"
});
var _ref200 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 01-.5-.5"
});
var _ref201 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 01-.5-.5z"
});
var _ref202 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 01-.5-.4"
});
var _ref203 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 01-.5-.4z"
});
var _ref204 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M277 205.4c0-.5.4-.8.8-.8s1 .3 1 .8-.5.8-1 .8a.9.9 0 01-.8-.8"
});
var _ref205 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M278.5 205.1v.6H277v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4"
});
var _ref206 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M278.5 205.1v.6H277v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4z"
});
var _ref207 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M279 205.1v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1"
});
var _ref208 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M278.1 204.6c.4 0 .6.4.6.8 0 .5-.4.8-.9.8a.9.9 0 01-.8-.8c0-.4.2-.7.6-.8"
});
var _ref209 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M268 212.2l-.6-.7a2.3 2.3 0 00-.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3v1"
});
var _ref210 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M268 212.2l-.6-.7a2.3 2.3 0 00-.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3v1z"
});
var _ref211 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5"
});
var _ref212 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5z"
});
var _ref213 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M287.5 212.2l.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 00-.4.2v-.2s-.3 0-.4.3v.7l.1.3"
});
var _ref214 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M287.5 212.2l.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 00-.4.2v-.2s-.3 0-.4.3v.7l.1.3z"
});
var _ref215 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5"
});
var _ref216 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z"
});
var _ref217 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M267.2 223h21.4v-5.5h-21.4v5.6z"
});
var _ref218 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M267.2 223h21.4v-5.5h-21.4v5.6z"
});
var _ref219 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M286.3 226.8a1 1 0 00-.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2"
});
var _ref220 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M286.3 226.8a1 1 0 00-.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2z"
});
var _ref221 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M269.9 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8"
});
var _ref222 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M269.9 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8z"
});
var _ref223 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6"
});
var _ref224 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6z"
});
var _ref225 = /*#__PURE__*/React.createElement("path", {
  fill: "#005bbf",
  d: "M263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 013.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 013.6-.8 8 8 0 013.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 01-3.8-.9 8.2 8.2 0 00-3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 01-3.7-.9 8.4 8.4 0 00-3.8-.8 8.3 8.3 0 00-3.7.8c-1 .5-2.3.9-3.8.9v-2.4"
});
var _ref226 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 013.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 013.6-.8 8 8 0 013.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 01-3.8-.9 8.2 8.2 0 00-3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 01-3.7-.9 8.4 8.4 0 00-3.8-.8 8.3 8.3 0 00-3.7.8c-1 .5-2.3.9-3.8.9v-2.4z"
});
var _ref227 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.9 3.7.9a8.2 8.2 0 003.8-.9 8.4 8.4 0 013.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 01-3.8-.9 8.1 8.1 0 00-3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 01-3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 00-3.7.7 8.1 8.1 0 01-3.8.9v-2.3"
});
var _ref228 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.9 3.7.9a8.2 8.2 0 003.8-.9 8.4 8.4 0 013.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 01-3.8-.9 8.1 8.1 0 00-3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 01-3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 00-3.7.7 8.1 8.1 0 01-3.8.9v-2.3"
});
var _ref229 = /*#__PURE__*/React.createElement("path", {
  fill: "#005bbf",
  d: "M263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7 1.4 0 2.8.2 3.8.7s2.3.9 3.7.9a8.2 8.2 0 003.8-.9 8.4 8.4 0 013.6-.8 8 8 0 013.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 01-3.8-.9 8.2 8.2 0 00-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 00-3.8-.8 8.3 8.3 0 00-3.7.8c-1 .5-2.3.8-3.8.8V322"
});
var _ref230 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7 1.4 0 2.8.2 3.8.7s2.3.9 3.7.9a8.2 8.2 0 003.8-.9 8.4 8.4 0 013.6-.8 8 8 0 013.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 01-3.8-.9 8.2 8.2 0 00-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 00-3.8-.8 8.3 8.3 0 00-3.7.8c-1 .5-2.3.8-3.8.8V322"
});
var _ref231 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M263 326.7a8 8 0 003.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 013.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 003.8.8v-2.3a8.3 8.3 0 01-3.8-.9 8.2 8.2 0 00-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 00-3.8-.8 8.3 8.3 0 00-3.7.8c-1 .5-2.3.8-3.8.8v2.3"
});
var _ref232 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M263 326.7a8 8 0 003.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 013.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 003.8.8v-2.3a8.3 8.3 0 01-3.8-.9 8.2 8.2 0 00-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 00-3.8-.8 8.3 8.3 0 00-3.7.8c-1 .5-2.3.8-3.8.8v2.3"
});
var _ref233 = /*#__PURE__*/React.createElement("path", {
  fill: "#005bbf",
  d: "M263 329a8.1 8.1 0 003.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8a8.2 8.2 0 003.8-.9 8.4 8.4 0 013.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 01-3.8-.8 8.2 8.2 0 00-3.7-.8 8.4 8.4 0 00-3.6.7 8.2 8.2 0 01-3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3"
});
var _ref234 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M263 329a8.1 8.1 0 003.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8a8.2 8.2 0 003.8-.9 8.4 8.4 0 013.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 01-3.8-.8 8.2 8.2 0 00-3.7-.8 8.4 8.4 0 00-3.6.7 8.2 8.2 0 01-3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3z"
});
var _ref235 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M286.3 308l-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5h16.8"
});
var _ref236 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M286.3 308l-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5h16.8z"
});
var _ref237 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7"
});
var _ref238 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7z"
});
var _ref239 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M266.9 316.7h22V311h-22v5.6z"
});
var _ref240 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M266.9 316.7h22V311h-22v5.6z"
});
var _ref241 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 01.2-8.8"
});
var _ref242 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 01.2-8.8z"
});
var _ref243 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M270.1 305.6h15.6V229h-15.6v76.5z"
});
var _ref244 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M281.4 229.1v76.3m1.8-76.3v76.3m-13 .2h15.5V229h-15.6v76.5z"
});
var _ref245 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M254.2 257.7a49.6 49.6 0 0123.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 00-9.2-.7c-6.7 0-12.4.8-15.9 2.1v9.4"
});
var _ref246 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M254.2 257.7a49.6 49.6 0 0123.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 00-9.2-.7c-6.7 0-12.4.8-15.9 2.1v9.4"
});
var _ref247 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3v7.4"
});
var _ref248 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3v7.4"
});
var _ref249 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M270 261.5a13 13 0 00-5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5"
});
var _ref250 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M270 261.5a13 13 0 00-5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5"
});
var _ref251 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7"
});
var _ref252 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7z"
});
var _ref253 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M263.9 254.4c.6-2.3 1.4-4.4 2.1-6.6h-.5a5.2 5.2 0 01-.5.1 52.8 52.8 0 01-1.4 4.8c-1-1.4-2-2.7-2.7-4.1l-1 .2h-1a131.3 131.3 0 014 5.7h.5l.5-.1m6-6.6h-1a8 8 0 01-.8 0v6.2h4.2v-.7h-2.6l.1-5.5m6.8 1l2 .3v-.7l-5.8-.5v.8a19.3 19.3 0 012 0l-.4 5.6h1.6l.5-5.4m2.4 6c.3 0 .5 0 .8.2l.8.2.7-2.9.6 1.2.8 2.1 1 .2c.4 0 .7.2 1 .3l-.3-.7c-.4-1-1-1.9-1.3-2.9 1 0 1.9-.3 2.1-1.2.1-.6 0-1-.7-1.5-.4-.3-1.2-.4-1.7-.5l-2.4-.5-1.4 6m3-5.2c.7.2 1.5.3 1.5 1v.5c-.3.9-1 1.2-2 .9l.5-2.4m8 7l-.2 2 .8.5.9.5.5-7a3.4 3.4 0 01-.7-.3l-6.1 3.8.5.3.4.2 1.7-1.2 2.3 1.3zm-1.7-1.5l2-1.4-.2 2.3-1.8-1"
});
var _ref254 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 01-2.1-2z"
});
var _ref255 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M205.7 175.4c6.3 0 12 1 15.7 2.4a31.7 31.7 0 0014.6 2.3c2.7 0 6.5.8 10.3 2.4a27.3 27.3 0 017.4 4.7l-1.5 1.4-.4 3.8-4.1 4.7-2 1.8-5 3.9-2.5.2-.7 2.1-31.6-3.7-31.7 3.7-.8-2.1-2.5-.2-4.9-4-2-1.7-4.1-4.7-.5-3.8-1.5-1.4a27.6 27.6 0 017.5-4.7 26 26 0 0110.2-2.4c2 .2 4.2.1 6.6-.2a30 30 0 008-2c3.7-1.5 9-2.5 15.5-2.5z"
});
var _ref256 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M206.2 217.1c-11.8 0-22.4-1.4-29.9-3.6a1.1 1.1 0 01-.8-1.2c0-.5.3-1 .8-1.2a109 109 0 0129.9-3.6c11.7 0 22.3 1.4 29.8 3.6a1.3 1.3 0 010 2.4c-7.5 2.2-18 3.6-29.8 3.6"
});
var _ref257 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0127.6 3c-7.3 2-17 3.2-27.6 3.2"
});
var _ref258 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M206.9 215.7v-6.3m-1.7 6.3v-6.3"
});
var _ref259 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.2,
  d: "M203.6 215.7v-6.3m-1.6 6.3v-6.3"
});
var _ref260 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M200.6 215.7v-6.3m-2.8 5.9v-5.7m1.3 5.8v-6m-3.8 5.6v-5.2m1.3 5.4v-5.6"
});
var _ref261 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M192 214.8V210m1 4.7V210m1.2 5v-5m-3.4 4.7v-4.5"
});
var _ref262 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M189.7 214.5v-4.2m-1.2 4.1v-4"
});
var _ref263 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.6,
  d: "M186 214v-3m1.3 3.2v-3.5m-2.5 3.1V211"
});
var _ref264 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.7,
  d: "M183.7 213.6v-2.3m-1.3 2v-1.8m-1.2 1.6v-1.3"
});
var _ref265 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.9,
  d: "M179.8 212.8v-.7"
});
var _ref266 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M213.7 215.3v-5.8m-2.9 6v-6.1m-2.1 6.2v-6.3"
});
var _ref267 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M206 207.4a108 108 0 00-30 3.9c.6-.3.5-1-.3-3-1-2.5-2.4-2.4-2.4-2.4 8.3-2.5 20-4 32.8-4a123 123 0 0133 4s-1.5-.1-2.5 2.3c-.8 2-.8 2.8-.2 3-7.5-2.2-18.4-3.7-30.3-3.7"
});
var _ref268 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M206.1 201.9c-12.9 0-24.5 1.5-32.8 4a1 1 0 01-1.3-.6 1 1 0 01.7-1.3 121 121 0 0133.4-4.2c13.2 0 25.2 1.7 33.5 4.2.6.2.9.8.7 1.3-.2.5-.8.8-1.3.6-8.4-2.5-20-4-32.9-4"
});
var _ref269 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.4,
  d: "M206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0127.6 3c-7.3 2-17 3.2-27.6 3.2z"
});
var _ref270 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M197 204.8c0-.5.4-1 1-1 .5 0 1 .5 1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref271 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M206.1 205.6H203a1 1 0 010-2h6.4c.5 0 1 .5 1 1s-.5 1-1 1h-3.2"
});
var _ref272 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M190.3 206.5l-2.3.2c-.6.1-1-.3-1.2-.8a1 1 0 011-1.1l2.2-.3 2.4-.3c.5 0 1 .3 1.1.9.1.5-.3 1-.9 1l-2.3.4"
});
var _ref273 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M181 206.7c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 01-1-1"
});
var _ref274 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M174 208.5l1.2-1.6 3.3.4-2.6 2-1.8-.8"
});
var _ref275 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M222 206.5l2.3.2c.5.1 1-.3 1.1-.8a1 1 0 00-.9-1.1l-2.2-.3-2.4-.3a1 1 0 00-1.1.9c-.1.5.3 1 .9 1l2.3.4"
});
var _ref276 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M213.3 204.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1m15.8 1.9c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.4 1-1 1a1 1 0 01-1-1"
});
var _ref277 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M238.2 208.5l-1.1-1.6-3.3.4 2.6 2 1.8-.8"
});
var _ref278 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M177.3 212.8c7.4-2.1 17.6-3.4 28.8-3.4 11.3 0 21.4 1.3 28.9 3.4"
});
var _ref279 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M182.3 183.8l1.4 1 2-3.2a7.4 7.4 0 01-3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 00-8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 003 7.6l-1 1.8"
});
var _ref280 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M182.3 183.8l1.4 1 2-3.2a7.4 7.4 0 01-3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 00-8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 003 7.6l-1 1.8"
});
var _ref281 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M182.4 183.8a9.3 9.3 0 01-4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 00-3.4 6.8 8.9 8.9 0 003 6.7l-.9 1.8"
});
var _ref282 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M182.4 183.8a9.3 9.3 0 01-4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 00-3.4 6.8 8.9 8.9 0 003 6.7l-.9 1.8"
});
var _ref283 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M160.1 187.1a8.8 8.8 0 01-2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 00-4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 00-.7 3.1 7.3 7.3 0 002.7 5.6l-2.6 4.1-1.3-1 1.7-2.8"
});
var _ref284 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M160.1 187.1a8.8 8.8 0 01-2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 00-4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 00-.7 3.1 7.3 7.3 0 002.7 5.6l-2.6 4.1-1.3-1 1.7-2.8z"
});
var _ref285 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M162.7 173.3a10.5 10.5 0 00-4 4.1 8.6 8.6 0 00-.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 01-2.3-6.5c0-4 2.5-7.5 6.4-9.8"
});
var _ref286 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M162.7 173.3a10.5 10.5 0 00-4 4.1 8.6 8.6 0 00-.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 01-2.3-6.5c0-4 2.5-7.5 6.4-9.8z"
});
var _ref287 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6"
});
var _ref288 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6z"
});
var _ref289 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 01.4-4.2 2 2 0 011.8-1.4"
});
var _ref290 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 01.4-4.2 2 2 0 011.8-1.4z"
});
var _ref291 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M229.7 183.8l-1.3 1-2-3.2a7.4 7.4 0 003.6-6.3 7 7 0 000-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 00-8.5 2.4 23 23 0 00-.2-1.8 17.4 17.4 0 018.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 01-3 7.6l1 1.8"
});
var _ref292 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M229.7 183.8l-1.3 1-2-3.2a7.4 7.4 0 003.6-6.3 7 7 0 000-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 00-8.5 2.4 23 23 0 00-.2-1.8 17.4 17.4 0 018.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 01-3 7.6l1 1.8"
});
var _ref293 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M229.6 183.8a9.1 9.1 0 004.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 013.4 6.8 8.9 8.9 0 01-3.2 6.7l1 1.8"
});
var _ref294 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M229.6 183.8a9.1 9.1 0 004.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 013.4 6.8 8.9 8.9 0 01-3.2 6.7l1 1.8"
});
var _ref295 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M252 187.1a8.8 8.8 0 002.2-5.9 8.7 8.7 0 00-.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 00-6 .6l1 1.4a25.4 25.4 0 015-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 01-2.6 5.6l2.5 4.1 1.3-1-1.7-2.8"
});
var _ref296 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M252 187.1a8.8 8.8 0 002.2-5.9 8.7 8.7 0 00-.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 00-6 .6l1 1.4a25.4 25.4 0 015-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 01-2.6 5.6l2.5 4.1 1.3-1-1.7-2.8z"
});
var _ref297 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M249.3 173.3a10.6 10.6 0 014 4.1 8.7 8.7 0 01.9 3.8 8.8 8.8 0 01-2.3 5.9l1.6 2.5a10.4 10.4 0 002.3-6.5c0-4-2.6-7.5-6.5-9.8"
});
var _ref298 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M249.3 173.3a10.6 10.6 0 014 4.1 8.7 8.7 0 01.9 3.8 8.8 8.8 0 01-2.3 5.9l1.6 2.5a10.4 10.4 0 002.3-6.5c0-4-2.6-7.5-6.5-9.8z"
});
var _ref299 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 01-1.8-1.7"
});
var _ref300 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 01-1.8-1.7z"
});
var _ref301 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M204.2 178c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 01-1.8-1.7m.4-3.7c0-.7.6-1.3 1.4-1.3.8 0 1.5.6 1.5 1.3 0 .8-.7 1.4-1.5 1.4s-1.4-.6-1.4-1.4m.4-3.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1m.2-2.8c0-.5.4-.8.8-.8.5 0 .9.3.9.8 0 .4-.4.8-.9.8a.8.8 0 01-.8-.8"
});
var _ref302 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M206.2 191.8l1.2.2a4.6 4.6 0 004.5 6 4.7 4.7 0 004.4-3c.1 0 .5-1.7.7-1.7.2 0 .1 1.8.2 1.7.3 2.3 2.4 3.8 4.7 3.8a4.6 4.6 0 004.7-5l1.5-1.5.7 2a4 4 0 00-.4 1.9 4.4 4.4 0 004.5 4.2c1.6 0 3-.7 3.8-1.9l.9-1.2v1.5c0 1.5.6 2.8 2 3 0 0 1.7.1 4-1.6 2.1-1.7 3.3-3.1 3.3-3.1l.2 1.7s-1.8 2.8-3.8 4c-1 .6-2.7 1.3-4 1-1.4-.2-2.4-1.3-3-2.6a6.7 6.7 0 01-3.3 1 6.5 6.5 0 01-6.1-3.7 7 7 0 01-10.4-.3 7 7 0 01-4.6 1.8 6.9 6.9 0 01-5.7-3 6.9 6.9 0 01-5.7 3 7 7 0 01-4.7-1.8 7 7 0 01-10.4.3 6.5 6.5 0 01-6 3.7 6.7 6.7 0 01-3.4-1c-.6 1.3-1.5 2.4-3 2.7-1.2.2-2.9-.5-4-1.1-2-1.2-3.8-4-3.8-4l.2-1.7s1.2 1.4 3.4 3.1c2.2 1.8 3.9 1.6 3.9 1.6 1.4-.2 2-1.5 2-3v-1.5l1 1.2a4.6 4.6 0 003.7 2c2.5 0 4.5-2 4.5-4.3a4 4 0 00-.4-2l.8-1.9 1.5 1.5a4.4 4.4 0 000 .6c0 2.4 2 4.4 4.6 4.4 2.4 0 4.4-1.5 4.7-3.8 0 0 0-1.6.2-1.7.2 0 .6 1.7.7 1.6a4.7 4.7 0 004.5 3.1 4.6 4.6 0 004.5-6l1.2-.2"
});
var _ref303 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M238.6 197.7c.3-.8 0-1.6-.6-1.8-.5-.2-1.2.3-1.5 1.1-.3.8 0 1.6.6 1.8.5.2 1.2-.3 1.5-1.1m-20.5-4c0-.8-.3-1.6-1-1.6-.5-.1-1 .5-1.2 1.4-.1.8.3 1.5.9 1.6.6 0 1.2-.6 1.3-1.4m-23.9 0c0-.8.4-1.6 1-1.6.6-.1 1.1.5 1.2 1.4.1.8-.3 1.5-.9 1.6-.6 0-1.1-.6-1.2-1.4m-20.6 4c-.2-.8 0-1.6.6-1.8.6-.2 1.2.3 1.5 1.1.3.8 0 1.6-.5 1.8-.6.2-1.3-.3-1.6-1.1"
});
var _ref304 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M182.7 184a5.1 5.1 0 012.2 2.9s0-.3.6-.6 1-.3 1-.3l-.1 1.3-.3 2.2a7.4 7.4 0 01-.7 1.6 1.9 1.9 0 00-1.5-.4 1.8 1.8 0 00-1.2.9s-.7-.6-1.2-1.3l-1.1-2-.7-1.1s.5-.2 1.1 0c.6 0 .8.2.8.2a4.9 4.9 0 011-3.4m.4 9.8a1.8 1.8 0 01-.6-1c0-.5 0-.9.3-1.2 0 0-.9-.5-1.8-.7-.7-.2-2-.2-2.3-.2h-1l.2.5c.2.5.5.7.5.7a5 5 0 00-3 2 5.3 5.3 0 003.5 1l-.2.8v.6l1-.4c.3-.1 1.5-.5 2-1 .8-.4 1.5-1.1 1.5-1.1m2.7-.5a1.6 1.6 0 00.2-1.1 1.7 1.7 0 00-.6-1l1.4-1.3a10 10 0 012-.9l1.1-.4v.6a5.7 5.7 0 01-.2.8 5 5 0 013.4 1 5 5 0 01-2.9 2 6.4 6.4 0 00.7 1.2h-1c-.4 0-1.6 0-2.3-.2a11 11 0 01-1.8-.7"
});
var _ref305 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 01-2.1-2"
});
var _ref306 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M206.1 180.8a5.7 5.7 0 011.9 3.7s.2-.3.9-.5c.7-.3 1.2-.2 1.2-.2l-.5 1.4-.8 2.4a8.2 8.2 0 01-1 1.7 2.1 2.1 0 00-1.7-.7c-.6 0-1.2.3-1.6.7 0 0-.6-.7-1-1.7l-.8-2.4-.5-1.4 1.2.2c.7.2.9.5.9.5 0-1.4.8-2.8 1.8-3.7"
});
var _ref307 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M204.6 191.8a2 2 0 01-.5-1.2c0-.5.1-1 .4-1.3 0 0-.8-.7-1.8-1-.7-.4-2-.7-2.5-.7l-1.2-.2.2.6.4.9a5.9 5.9 0 00-3.7 1.7c1 .9 2.3 1.6 3.7 1.6l-.4 1-.2.6 1.2-.2c.4-.1 1.8-.4 2.5-.7 1-.4 1.9-1 1.9-1m3 0a1.9 1.9 0 00.1-2.6s.9-.7 1.8-1a8 8 0 012.5-.7l1.2-.3-.1.7-.4.9c1.4 0 2.7.8 3.6 1.7a5.9 5.9 0 01-3.6 1.6 6.9 6.9 0 00.5 1.6l-1.2-.2-2.5-.7c-1-.4-1.8-1-1.8-1m22-8a5.2 5.2 0 00-2.2 3l-.7-.6c-.6-.3-1-.3-1-.3l.2 1.3c0 .3 0 1.3.3 2.2.2 1 .6 1.6.6 1.6a2 2 0 011.5-.4c.6.1 1 .5 1.3.9l1.1-1.3c.6-.8 1-1.7 1.1-2l.7-1.1s-.4-.2-1 0c-.7 0-1 .2-1 .2a4.9 4.9 0 00-1-3.4m-.3 9.8c.3-.3.5-.6.6-1a1.6 1.6 0 00-.2-1.2s.8-.5 1.7-.7c.7-.2 2-.2 2.3-.2h1.1l-.3.5a6.2 6.2 0 01-.4.7 5 5 0 012.9 2 5.3 5.3 0 01-3.5 1l.2.8v.6l-1-.4c-.3-.1-1.4-.5-2-1-.8-.4-1.4-1.1-1.4-1.1m-2.8-.5a1.7 1.7 0 01-.2-1.1c0-.5.3-.8.6-1 0 0-.6-.8-1.4-1.3-.6-.4-1.7-.8-2-.9a171.4 171.4 0 01-1-.4v.6c0 .5.2.8.2.8a5.2 5.2 0 00-3.5 1c.7.9 1.7 1.7 3 2 0 0-.3.2-.5.7l-.3.5h1c.4 0 1.7 0 2.3-.2a11.1 11.1 0 001.8-.7"
});
var _ref308 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M226 192.4c0-1 1-2 2-2s2.1 1 2.1 2a2 2 0 01-2 2 2 2 0 01-2.1-2m23.2 4.4c-.4-.5-1.4-.4-2.2.2-.8.7-1 1.6-.5 2.2.5.5 1.5.4 2.3-.3.7-.6 1-1.6.5-2"
});
var _ref309 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M246.3 198l.7-1c.7-.6 1.8-.7 2.3-.2l.1.2s1-2 2.3-2.6c1.3-.7 3.4-.5 3.4-.5a2.8 2.8 0 00-2.9-2.8 3 3 0 00-2.4 1l-.2-1s-1.3.3-1.9 1.8c-.6 1.5 0 3.6 0 3.6s-.3-.9-.7-1.5a8 8 0 00-2.4-1.6l-1.3-.7-.1.5a5 5 0 000 .8 7.9 7.9 0 00-3.7.5 4.7 4.7 0 002.5 2.2l-.8.7a4 4 0 00-.4.5l1.3.2 2.5.2a14.5 14.5 0 001.7-.2m-80.3 0c0-.4-.3-.7-.7-1-.7-.7-1.7-.8-2.2-.3l-.2.3s-1-2-2.3-2.7c-1.2-.7-3.3-.5-3.3-.5a2.8 2.8 0 012.8-2.8c1 0 1.9.4 2.4 1l.2-1s1.3.3 2 1.8c.5 1.5-.1 3.6-.1 3.6s.3-.9.8-1.5a8 8 0 012.4-1.6l1.3-.7v1.3a7.9 7.9 0 013.7.5 4.7 4.7 0 01-2.5 2.2l.8.7.4.5-1.2.2-2.6.2a14.7 14.7 0 01-1.7-.2"
});
var _ref310 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M163 196.8c.6-.5 1.6-.4 2.4.3.7.6 1 1.5.4 2-.5.6-1.5.5-2.2-.2-.8-.6-1-1.6-.5-2m41-6.3c0-1.1.9-2 2-2s2.1.9 2.1 2c0 1-1 2-2 2a2 2 0 01-2.1-2"
});
var _ref311 = /*#__PURE__*/React.createElement("path", {
  fill: "#005bbf",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M201.8 160.6c0-2.2 1.9-4 4.3-4s4.2 1.8 4.2 4-1.9 4-4.3 4a4.1 4.1 0 01-4.2-4"
});
var _ref312 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M205 149.3v2.2h-2.4v2.2h2.3v6.3H202l-.2.6c0 .6.1 1.1.3 1.6h7.9c.2-.5.3-1 .3-1.6l-.2-.6h-2.8v-6.3h2.3v-2.2h-2.3v-2.2h-2.4z"
});
var _ref313 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M206.5 330.6a82 82 0 01-35.5-8.2 22.7 22.7 0 01-12.8-20.4v-32h96.4v32a22.7 22.7 0 01-12.8 20.4 81 81 0 01-35.3 8.2"
});
var _ref314 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M206.5 330.6a82 82 0 01-35.5-8.2 22.7 22.7 0 01-12.8-20.4v-32h96.4v32a22.7 22.7 0 01-12.8 20.4 81 81 0 01-35.3 8.2z"
});
var _ref315 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M206.3 270h48.3v-53.5h-48.3V270z"
});
var _ref316 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M206.3 270h48.3v-53.5h-48.3V270z"
});
var _ref317 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32"
});
var _ref318 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M168.6 320.9c1.5.8 3.6 2 5.8 2.6l-.1-54.7h-5.7v52z"
});
var _ref319 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.5,
  d: "M158 301.6a24.4 24.4 0 005.5 15v-47.5h-5.4v32.5z"
});
var _ref320 = /*#__PURE__*/React.createElement("path", {
  fill: "#c7b500",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M179.4 324.7a26.6 26.6 0 005.6 0v-55.9h-5.6v56z"
});
var _ref321 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M190 323.5a19 19 0 005.8-2.5v-52.2H190l-.1 54.7z"
});
var _ref322 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M158.1 270h48.2v-53.5H158V270z"
});
var _ref323 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M158.1 270h48.2v-53.5H158V270z"
});
var _ref324 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M201 316c2.4-2 4.6-6.8 5.4-12.2l.1-35H201l.1 47.3z"
});
var _ref325 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32"
});
var _ref326 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3"
});
var _ref327 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3"
});
var _ref328 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M215.1 294.1l.1.5c0 .6-.5 1-1.1 1a1 1 0 01-1.1-1v-.5h-1.5a2.5 2.5 0 001.8 2.9v3.9h1.6V297a2.6 2.6 0 001.7-1.6h4.4v-1.2h-6m21.8 0v1.2h-4a2.5 2.5 0 01-.3.6l4.6 5.2-1.2 1-4.6-5.3-.2.1v8.7h-1.6V297h-.2l-4.8 5.2-1.2-1 4.7-5.3a2.1 2.1 0 01-.2-.4h-4V294h13zm2.6 0v1.2h4.4c.3.8.9 1.4 1.7 1.6v3.9h1.6V297a2.5 2.5 0 001.8-2.4 2 2 0 000-.5h-1.6l.1.5c0 .6-.5 1-1 1-.7 0-1.2-.4-1.2-1a1 1 0 01.1-.5h-5.9m-6.7 22.1a15.6 15.6 0 003.7-1l.8 1.4a17.6 17.6 0 01-4.3 1.2 2.6 2.6 0 01-2.6 2 2.6 2.6 0 01-2.5-2 17.5 17.5 0 01-4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 011.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-11-2.2l-.8 1.4a16.6 16.6 0 01-3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 01-.3-3.5l.1-.1a15.3 15.3 0 01-1.3-4.8h1.7a13.1 13.1 0 001 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.5.9.5 2-.1 2.8a15.2 15.2 0 003.1 2.6zm-6-4.8c.3-.4 1-.5 1.5 0s.5 1 .1 1.4a1.2 1.2 0 01-1.6.1 1 1 0 010-1.5zm-2.2-4.5l-1.6-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.2 2.7zm1.4-5.3l1.7.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6a14 14 0 01-.3-2.7v-2.6zm5.6 13.7a15.7 15.7 0 004.8 2.6l.4-1.6a13.7 13.7 0 01-4-2l-1.2 1m-.8 1.4a17.4 17.4 0 004.8 2.6l-1.2 1.1a18.7 18.7 0 01-4-2l.4-1.7m2.2-9.4l1.6.7 3-3.3-1-1.4-3.6 4m-1.3-1l-1-1.4 3-3.3 1.6.7-3.6 4m18.1 9.9l.8 1.4a16.7 16.7 0 003.6-3.1c.9.2 1.8 0 2.5-.5a2.4 2.4 0 00.3-3.5l-.1-.1a15 15 0 001.3-4.8h-1.7a13.3 13.3 0 01-1 4 3 3 0 00-1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 00.1 2.8 15 15 0 01-3.1 2.6zm6-4.8a1.2 1.2 0 00-1.5 0 1 1 0 00-.1 1.4 1.2 1.2 0 001.6.1 1 1 0 000-1.5zm2.2-4.5l1.6-.3.3-4.3-1.7-.6v2.5c0 1 0 1.9-.2 2.8zm-1.4-5.3l-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7v-2.6m-5.6 13.7a15.7 15.7 0 01-4.8 2.6l-.4-1.6a13.7 13.7 0 004-2l1.2 1m.8 1.4a17.4 17.4 0 01-4.8 2.6l1.2 1.1a18.6 18.6 0 004-2l-.4-1.7m-2.2-9.4l-1.6.7-2.9-3.3 1-1.4 3.5 4m1.3-1l1-1.4-3-3.3-1.6.7 3.6 4m-20.1-8.7l.5 1.6h4.5l.5-1.6h-5.5m21.1 0l-.5 1.6h-4.5l-.5-1.6h5.5m-11.6 21.9c0-.6.5-1 1.1-1a1 1 0 011.1 1c0 .6-.5 1-1 1a1.1 1.1 0 01-1.2-1zm1.9-7.8l1.7-.4v-4.3l-1.7-.5v5.2m-1.6 0l-1.7-.4v-4.3l1.7-.5v5.2"
});
var _ref329 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M211.5 294.2c.2-1 1-1.6 1.8-2V287h1.6v5.3c.8.3 1.5.9 1.7 1.6h4.4v.3h-6a1.2 1.2 0 00-1-.6c-.4 0-.7.3-1 .6h-1.5m12.2 0v-.3h4.1a2.4 2.4 0 01.2-.3l-5-5.7 1.2-1 5 5.6.2-.1V285h1.6v7.3h.3l4.9-5.5 1.2 1-4.9 5.5.3.6h4v.3h-13zm21.6 0a1.1 1.1 0 011-.6c.5 0 .8.3 1 .6h1.6c-.2-1-.9-1.6-1.8-2V287h-1.6v5.3c-.8.3-1.4.8-1.7 1.6h-4.4v.3h6m-30.2-15l6 6.8 1.3-1-6.1-6.7.3-.6h4.4V276h-4.4a2.6 2.6 0 00-2.5-1.7 2.6 2.6 0 00-2.7 2.5 2.5 2.5 0 001.8 2.4v5.2h1.6v-5.2h.3zm32 0v5.3h-1.7v-5.2a2.5 2.5 0 01-.4-.2l-6 6.8-1.3-1 6.2-6.9-.1-.3h-4.5V276h4.5a2.6 2.6 0 012.4-1.7 2.6 2.6 0 012.7 2.5 2.5 2.5 0 01-1.9 2.4zm-16.1 0v3.3h-1.7v-3.2a2.6 2.6 0 01-1.7-1.6h-4V276h4a2.6 2.6 0 012.5-1.7c1.2 0 2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 01-1.6 1.6zm-17.8 4l-1.7.4v4.3l1.7.5v-5.2m1.6 0l1.7.4v4.3l-1.7.5v-5.2m30.6 0l-1.7.4v4.3l1.7.5v-5.2m1.6 0l1.7.4v4.3l-1.7.5v-5.2m-25.5.8l1.6-.7 2.9 3.3-1 1.4-3.5-4m-1.3 1l-1 1.4 3 3.3 1.6-.7-3.6-4m18.5-1.1l-1.6-.7-3 3.3 1 1.4 3.6-4m1.2 1l1 1.4-3 3.3-1.5-.7 3.5-4m-20.3 9l.5-1.6h4.5l.5 1.6h-5.5m-6.7-17c0-.6.5-1 1.2-1a1 1 0 011 1c0 .6-.4 1-1 1a1.1 1.1 0 01-1.2-1zm12.1.8l-.5 1.6h-4.5l-.5-1.6h5.5m0-1.6l-.5-1.6h-4.5l-.5 1.6h5.5m15.7 17.8l-.5-1.6h-4.5l-.5 1.6h5.5m4.4-17c0-.6.5-1 1.1-1a1 1 0 011.1 1c0 .6-.5 1-1 1a1.1 1.1 0 01-1.2-1zm-16.1 0c0-.6.5-1 1.1-1a1 1 0 011.1 1c0 .6-.5 1-1.1 1a1.1 1.1 0 01-1.1-1zm6.2.8l.5 1.6h4.6l.5-1.6h-5.6m0-1.6l.5-1.6h4.6l.5 1.6h-5.6m-5.9 5l-1.7.5v4.3l1.7.5V281m1.7 0l1.6.5v4.3l-1.6.5V281"
});
var _ref330 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#c8b100",
  strokeWidth: 0.3,
  d: "M232.7 316.3a15.6 15.6 0 003.7-1.1l.8 1.4a17.6 17.6 0 01-4.3 1.2 2.6 2.6 0 01-2.6 2 2.6 2.6 0 01-2.5-2 17.5 17.5 0 01-4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 011.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-4.7-20.4a2.3 2.3 0 01-.2-.5h-4V294h4a2.6 2.6 0 01.2-.4l-5-5.6 1.2-1 5 5.5a2.2 2.2 0 01.2 0V285h1.7v7.3h.2l4.9-5.5 1.2 1-4.9 5.5.3.6h4v1.5h-4c0 .2-.2.4-.3.5l4.7 5.3-1.3 1-4.6-5.3-.2.1v8.7h-1.6V297l-.2-.1-4.8 5.3-1.2-1 4.7-5.3m-12.8-16.7l6 6.8 1.3-1-6.1-6.7.3-.6h4.4V276h-4.4a2.6 2.6 0 00-2.5-1.7 2.6 2.6 0 00-2.6 2.5 2.5 2.5 0 001.7 2.4v5.2h1.6v-5.2h.3zm6.5 34.8l-.8 1.4a16.6 16.6 0 01-3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 01-.3-3.5l.1-.1a15.3 15.3 0 01-1.2-4.8h1.6a13.1 13.1 0 001 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.6.9.5 2-.1 2.8a15.2 15.2 0 003.1 2.6zm-8.4-13.1V297a2.5 2.5 0 01-1.8-2.4c0-1 .8-2 1.8-2.4V287h1.6v5.3c.8.2 1.5.8 1.7 1.6h4.4v1.5h-4.4a2.6 2.6 0 01-1.6 1.6v3.9h-1.7m2.3 8.3c.4-.4 1.1-.5 1.6 0s.5 1 .1 1.4a1.2 1.2 0 01-1.6.1 1 1 0 010-1.5zm-2-4.5l-1.7-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.3 2.7zm1.4-5.3l1.6.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6-.3-2.7v-2.6zm5.5 13.7a15.7 15.7 0 004.8 2.6l.4-1.6a13.7 13.7 0 01-4-2l-1.2 1m-.8 1.4a17.4 17.4 0 004.8 2.6l-1.2 1.1a18.7 18.7 0 01-4-2l.4-1.7"
});
var _ref331 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#c8b100",
  strokeWidth: 0.3,
  d: "M221.9 305.1l1.6.7 3-3.3-1-1.4-3.6 4m-1.3-1l-1-1.4 3-3.3 1.6.7-3.6 4m-7.6-9.5c0-.6.5-1 1-1 .7 0 1.2.5 1.2 1 0 .6-.5 1.1-1.1 1.1a1 1 0 01-1.1-1zm25.7 19.4l.8 1.4a16.7 16.7 0 003.6-3.1c.9.2 1.8 0 2.6-.5a2.4 2.4 0 00.2-3.5l-.1-.1a15 15 0 001.3-4.8h-1.7a13.3 13.3 0 01-1 4 3 3 0 00-1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 00.1 2.8 15 15 0 01-3 2.6zm8.4-13.1V297a2.5 2.5 0 001.8-2.4c0-1-.7-2-1.8-2.4V287h-1.6v5.3c-.8.2-1.4.8-1.7 1.6h-4.4v1.5h4.4c.3.8.9 1.3 1.7 1.6v3.9h1.6zm-2.3 8.3a1.2 1.2 0 00-1.6 0 1 1 0 00-.1 1.4 1.2 1.2 0 001.6.1 1 1 0 000-1.5zm2-4.5l1.7-.3.3-4.3-1.7-.6v2.5c0 1 0 1.8-.2 2.7zm-1.3-5.3l-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7v-2.6m1.6-20.1v5.2h-1.6v-5.2a2.3 2.3 0 01-.4-.2l-6 6.8-1.2-1 6-7v-.2h-4.5V276h4.4a2.6 2.6 0 012.5-1.7 2.6 2.6 0 012.6 2.5 2.5 2.5 0 01-1.8 2.4zm-16 0v3.2h-1.7v-3.2a2.6 2.6 0 01-1.7-1.6h-4V276h4c.4-1 1.3-1.7 2.5-1.7s2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 01-1.6 1.6zm8.8 33.8a15.7 15.7 0 01-4.8 2.6l-.4-1.6a13.7 13.7 0 004-2l1.2 1m.8 1.4a17.4 17.4 0 01-4.8 2.6l1.2 1.1a18.7 18.7 0 004-2l-.4-1.7m-27.4-31.4l-1.7.5v4.3l1.7.5v-5.2m1.7 0l1.6.4v4.3l-1.6.5V283m30.5 0l-1.7.5v4.3l1.7.5V283"
});
var _ref332 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#c8b100",
  strokeWidth: 0.3,
  d: "M247.1 283.1l1.7.5v4.3l-1.7.5V283m-8.6 22l-1.6.7-2.9-3.3 1-1.4 3.5 4m1.3-1l1-1.4-3-3.3-1.6.7 3.6 4m-18.2-20l1.6-.7 3 3.3-1 1.4-3.6-4m-1.3 1l-1 1.4 3 3.3 1.6-.7-3.6-4m18.5-1.1l-1.6-.7-3 3.3 1 1.4 3.6-4m1.2 1l1 1.4-3 3.2-1.5-.6 3.5-4m-20.3 9l.5-1.6h4.5l.5 1.6h-5.5m0 1.5l.5 1.6h4.5l.5-1.6h-5.5M213 277c0-.6.5-1 1.2-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 01-1.2-1zm12.1.8l-.5 1.6h-4.5l-.5-1.6h5.5m0-1.6l-.5-1.6h-4.5l-.5 1.6h5.5m20.1 18.5c0-.5.5-1 1.1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1.1-1 1.1a1 1 0 01-1.2-1zm-4.4-.7l-.5-1.6h-4.5l-.5 1.6h5.5m0 1.5l-.5 1.6h-4.5l-.5-1.6h5.5m-11.6 21.9c0-.6.5-1 1.1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1.1 1.1 0 01-1.2-1zm1.9-7.8l1.7-.4v-4.3l-1.7-.5v5.2m-1.6 0l-1.7-.4v-4.3l1.7-.5v5.2m15.7-32.6c0-.6.5-1 1.1-1a1 1 0 011.1 1c0 .6-.5 1-1 1a1.1 1.1 0 01-1.2-1zm-16.1 0c0-.6.5-1 1.1-1a1 1 0 011.1 1c0 .6-.5 1-1 1a1.1 1.1 0 01-1.2-1zm6.2.8l.5 1.6h4.6l.5-1.6h-5.5m0-1.6l.4-1.6h4.6l.5 1.6h-5.5m-6 5l-1.6.5v4.3l1.6.5V281m1.7 0l1.6.5v4.3l-1.6.5V281"
});
var _ref333 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  d: "M227.7 294.7a2.6 2.6 0 012.6-2.5 2.6 2.6 0 012.6 2.5 2.6 2.6 0 01-2.6 2.4c-1.4 0-2.6-1-2.6-2.4"
});
var _ref334 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 01-2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1l1.8.2"
});
var _ref335 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 01-2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1l1.8.2z"
});
var _ref336 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed72aa",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M238.1 227.5v1.4c.2.6-.1 1.2 0 1.5 0 .4.1.6.3.9l.2.9-.7-.5-.6-.4v1c.1.2.3.8.6 1.1l1 1.3c.2.5.1 1.4.1 1.4s-.4-.7-.8-.8l-1.2-.7s.7.8.7 1.5c0 .8-.3 1.6-.3 1.6s-.3-.7-.8-1.1l-1-.9s.4 1.2.4 2v2.3l-.9-1-1-.7c0-.2.5.6.6 1.1 0 .5.3 2.3 1.8 4.5 1 1.3 2.3 3.6 5.3 2.9 3-.8 1.9-4.8 1.3-6.7a16.8 16.8 0 01-1-4.6c0-.8.6-2.9.5-3.3a8 8 0 01.2-3.1c.4-1.3.7-1.8.9-2.3.2-.6.4-.9.4-1.3l.1-1.3.7 1.3.1 1.5s.1-1 1-1.6c.8-.6 1.8-1.1 2-1.4.3-.3.3-.5.3-.5s0 1.8-.6 2.6l-1.7 2s.7-.3 1.2-.3h.9s-.6.4-1.4 1.6c-.8 1-.5 1.2-1 2.1-.6 1-1 1-1.7 1.5-1 .8-.5 4.2-.4 4.7.2.5 2 4.5 2 5.5s.2 3.2-1.5 4.6c-1.1 1-3 1-3.4 1.2-.4.3-1.2 1.1-1.2 2.8 0 1.7.6 2 1 2.4.6.5 1.2.2 1.3.6.2.3.2.5.5.7.2.2.3.4.2.8 0 .3-.8 1.1-1.1 1.7l-.8 2.4c0 .2-.1 1 .1 1.3 0 0 .9 1 .3 1.2-.4.2-.8-.2-1-.2l-.9.5c-.3-.1-.3-.3-.4-.8l-.1-.7c-.2 0-.3.2-.4.5 0 .2 0 .8-.3.8-.2 0-.5-.4-.8-.5-.2 0-.8-.2-.8-.4 0-.3.4-.9.7-1 .4 0 .8-.3.5-.5s-.5-.2-.7 0-.8 0-.7-.2v-.8c0-.2-.4-.5.1-.8.6-.3.8.2 1.4.1.6 0 .8-.3 1-.6.2-.3.2-1-.2-1.4-.4-.5-.7-.5-.9-.8l-.3-.9v2.2l-.7-.8c-.3-.3-.6-1.3-.6-1.3v1.3c0 .4.3.7.2.8-.1.1-.8-.7-1-.8a3.7 3.7 0 01-1-1l-.4-1.4a4.2 4.2 0 010-1.5l.4-1h-1.4c-.7 0-1.2-.3-1.5.2-.3.5-.2 1.5.2 2.8.3 1.2.5 1.9.4 2.1a3 3 0 01-.7.8h-.9a2.5 2.5 0 00-1.2-.3h-1.3l-1.1-.3c-.3.1-.8.3-.6.7.2.6-.2.7-.5.7l-.9-.2c-.4-.1-.9 0-.8-.4 0-.4.2-.4.4-.7.2-.3.2-.5 0-.5h-.6c-.2.2-.5.5-.8.4-.2-.1-.4-.4-.4-1s-.7-1.2 0-1.1c.5 0 1.3.4 1.4 0 .2-.3 0-.4-.2-.7s-.8-.4-.3-.7l.7-.5c.1-.2.4-.8.7-.6.6.2 0 .7.6 1.3.6.7 1 1 2 .8 1 0 1.3-.2 1.3-.5l-.1-1v-1s-.4.3-.5.6l-.4.8v-2a8 8 0 00-.2-.8l-.3.9-.1 1s-.7-.5-.5-1.5c.1-.7-.1-1.6.1-2 .2-.3.7-1.5 2-1.6h2.6l2-.3s-2.8-1.4-3.5-1.9a9.5 9.5 0 01-2-2l-.6-1.6s-.5 0-1 .3a5 5 0 00-1.2 1l-.7 1 .1-1.2v-.8s-.4 1.2-1 1.7l-1.4 1v-.8l.2-1s-.4.8-1.1 1c-.7 0-1.8 0-1.9.4 0 .5.2 1 0 1.4 0 .3-.4.5-.4.5l-.8-.4c-.4 0-.7.2-.7.2s-.3-.4-.2-.7c.1-.2.7-.6.5-.8l-.8.2c-.3.1-.8.3-.8-.2 0-.4.2-.7 0-1 0-.3 0-.5.2-.6l1.2-.1c0-.2-.2-.5-.8-.6-.6-.1-.8-.5-.5-.8.3-.2.3-.3.5-.6.1-.2.2-.7.7-.5.5.3.4.8 1 1a4 4 0 002-.2l1.5-1 1.5-1-1-.8c-.3-.3-.7-.9-1-1a8.3 8.3 0 00-1.8-.6 9 9 0 01-1.7-.5l.8-.3c.2-.2.6-.6.8-.6h.3-1.4c-.3-.1-1-.6-1.3-.6l-.8.1s.8-.4 1.4-.5l1-.1s-.9-.3-1.1-.6l-.6-1c-.2-.1-.3-.5-.6-.5l-1 .3c-.4 0-.6-.2-.6-.6l-.1-.5c-.2-.3-.6-.8-.2-1h1.4c0-.2-.5-.6-.8-.8-.4-.2-1-.5-.7-.8l.8-.5c.2-.3.3-1 .7-.7.4.2.8 1.2 1.1 1.1.3 0 .3-.8.3-1 0-.4 0-1 .2-.9.3 0 .5.4 1 .5.4 0 1-.1 1 .2 0 .3-.3.7-.6 1-.3.3-.4 1-.3 1.4.2.5.7 1.2 1.2 1.4.4.3 1.2.5 1.7.9.5.3 1.7 1.2 2.1 1.3l.8.4s.5-.2 1.1-.2c.7 0 2.1 0 2.6-.2.6-.2 1.3-.6 1-1-.1-.6-1.3-1-1.2-1.4 0-.4.5-.4 1.2-.4.8 0 1.8.1 2-1 .2-1 .2-1.5-.8-1.8-1-.2-1.8-.2-2-1-.2-.7-.4-.9-.2-1.1.3-.2.6-.3 1.4-.4.8 0 1.6 0 1.9-.2.2-.2.3-.7.6-.9.3-.2 1.4-.4 1.4-.4s1.4.7 2.7 1.7a15 15 0 012.2 2.1"
});
var _ref337 = /*#__PURE__*/React.createElement("path", {
  d: "M228.1 226.8l-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3l-.2.3"
});
var _ref338 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M228.1 226.8l-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3l-.2.3z"
});
var _ref339 = /*#__PURE__*/React.createElement("path", {
  d: "M232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3h-.3"
});
var _ref340 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3h-.3z"
});
var _ref341 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M237.3 231.3l-.4-.7a8 8 0 01-.3-.4"
});
var _ref342 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 01-.6.8"
});
var _ref343 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 01-.6.8z"
});
var _ref344 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 00.4-.6"
});
var _ref345 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 00.4-.6z"
});
var _ref346 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M214.2 230.6s-.8.1-1.2.6c-.4.5-.3 1.3-.3 1.3s.4-.5.9-.5l1 .2-.1-.8-.3-.8"
});
var _ref347 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M214.2 230.6s-.8.1-1.2.6c-.4.5-.3 1.3-.3 1.3s.4-.5.9-.5l1 .2-.1-.8-.3-.8z"
});
var _ref348 = /*#__PURE__*/React.createElement("path", {
  d: "M228.2 230.5l.3-.5.3.5h-.7"
});
var _ref349 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M228.2 230.5l.3-.5.3.5h-.7"
});
var _ref350 = /*#__PURE__*/React.createElement("path", {
  d: "M229 230.5l.3-.5.4.5h-.8"
});
var _ref351 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M229 230.5l.3-.5.4.5h-.8"
});
var _ref352 = /*#__PURE__*/React.createElement("path", {
  d: "M228.6 227.3l.8.3-.7.4-.1-.6"
});
var _ref353 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M228.6 227.3l.8.3-.7.4-.1-.6"
});
var _ref354 = /*#__PURE__*/React.createElement("path", {
  d: "M229.5 227.6l.7.2-.5.4-.2-.6"
});
var _ref355 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M229.5 227.6l.7.2-.5.4-.2-.6"
});
var _ref356 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M224.2 233.7s-.7.2-1 .6c-.4.5-.3 1-.3 1s.6-.5 1.5-.3l1.2.3 1.3-.3s-.7.8-.7 1.3l.2 1.1c0 .7-.6 1.6-.6 1.6l1-.3a4.6 4.6 0 001.7-.8l.9-1s-.2 1 0 1.4l.2 1.6.8-.6c.2-.1.7-.4.9-.7l.3-1s0 .8.4 1.3l.6 1.6s.3-.8.6-1.1c.3-.4.7-.8.7-1a4.3 4.3 0 00-.1-.9l.4.8m-11 .6s.5-.8 1-1l1.1-.8.9-.4m1 5l1.3-.8a4 4 0 001-1"
});
var _ref357 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4.3-.6"
});
var _ref358 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4.3-.6z"
});
var _ref359 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8"
});
var _ref360 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8z"
});
var _ref361 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3h-.7"
});
var _ref362 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3h-.7zm16 1.3s2 1.2 1.9 2.2c0 1-1 2.3-1 2.3"
});
var _ref363 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M224.2 252.6s-.4-.6-1.1-.6c-.7 0-1.4.7-1.4.7s.8-.1 1 .2l.5.6.5-.3.5-.6"
});
var _ref364 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M224.2 252.6s-.4-.6-1.1-.6c-.7 0-1.4.7-1.4.7s.8-.1 1 .2l.5.6.5-.3.5-.6z"
});
var _ref365 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7"
});
var _ref366 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7z"
});
var _ref367 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2"
});
var _ref368 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2z"
});
var _ref369 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8l-.2-.4"
});
var _ref370 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8l-.2-.4z"
});
var _ref371 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 01-.7-.3"
});
var _ref372 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 01-.7-.3z"
});
var _ref373 = /*#__PURE__*/React.createElement("path", {
  fill: "#db4446",
  d: "M239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3"
});
var _ref374 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3z"
});
var _ref375 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd691",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M208.8 316.4c2 .6 3 2 3 3.8 0 2.3-2.2 4-5 4-3 0-5.3-1.7-5.3-4 0-1.7 1-3.6 3-3.8l-.2-.4-.7-.7h1.2l.8.5.5-.7c.3-.4.6-.5.6-.5l.6.6.3.5.7-.4.8-.3s0 .4-.2.7l-.1.7"
});
var _ref376 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M206.3 326.7s-3.8-2.6-5.5-3c-2-.4-4.5 0-5.5 0 0 0 1.2.8 1.8 1.4.5.5 2.3 1.5 3.3 1.8 3 .8 6-.2 6-.2m1 .2s2.4-2.5 5-2.9c3-.4 5 .3 6.2.6l-1.5.8c-.5.3-2 1.5-4 1.6-2 0-4.4-.3-4.8-.2l-.9.1"
});
var _ref377 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M206.7 323.8a4.8 4.8 0 010-7.1 4.8 4.8 0 011.5 3.5 4.9 4.9 0 01-1.5 3.6"
});
var _ref378 = /*#__PURE__*/React.createElement("path", {
  fill: "#058e6e",
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M205.7 329s.6-1.5.6-2.7l-.1-2.1h.8s.3 1.1.3 2l-.1 2.4-.7.1-.8.3"
});
var _ref379 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 01-1-1"
});
var _ref380 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 01-1-1z"
});
var _ref381 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M255.4 188.2c0-.6.5-1 1.1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref382 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M255.4 188.2c0-.6.5-1 1.1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref383 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1"
});
var _ref384 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1z"
});
var _ref385 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 01-1-1"
});
var _ref386 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 01-1-1z"
});
var _ref387 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 01-1-1"
});
var _ref388 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 01-1-1z"
});
var _ref389 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref390 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref391 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref392 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref393 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M249.4 171.8c0-.5.5-1 1.1-1a1 1 0 010 2c-.6 0-1-.4-1-1"
});
var _ref394 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M249.4 171.8c0-.5.5-1 1.1-1a1 1 0 010 2c-.6 0-1-.4-1-1z"
});
var _ref395 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref396 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref397 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M243.3 169.1c0-.5.5-1 1.1-1a1 1 0 010 2 1 1 0 01-1-1"
});
var _ref398 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M243.3 169.1c0-.5.5-1 1.1-1a1 1 0 010 2 1 1 0 01-1-1z"
});
var _ref399 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref400 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref401 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref402 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref403 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref404 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref405 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1"
});
var _ref406 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1z"
});
var _ref407 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M231.7 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1m.6 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 01-1-1m0 3c0-.5.6-1 1.1-1a1 1 0 010 2 1 1 0 01-1-1m-1 2.8c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1 0 .6-.4 1-1 1a1 1 0 01-1-1m-1.9 2.6c0-.5.5-1 1-1 .7 0 1.2.5 1.2 1s-.5 1-1.1 1c-.6 0-1-.4-1-1"
});
var _ref408 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M227.6 166.5c0-.5.5-1 1.1-1a1 1 0 010 2 1 1 0 01-1-1"
});
var _ref409 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M227.6 166.5c0-.5.5-1 1.1-1a1 1 0 010 2 1 1 0 01-1-1z"
});
var _ref410 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref411 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref412 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1"
});
var _ref413 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1z"
});
var _ref414 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1"
});
var _ref415 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1z"
});
var _ref416 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M215 163.5c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 01-1-1"
});
var _ref417 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M215 163.5c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref418 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref419 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref420 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1"
});
var _ref421 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1z"
});
var _ref422 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 01-1-1"
});
var _ref423 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref424 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref425 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref426 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref427 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref428 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 01-1-1"
});
var _ref429 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 01-1-1z"
});
var _ref430 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref431 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref432 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 01-1-1"
});
var _ref433 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 01-1-1z"
});
var _ref434 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref435 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref436 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref437 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref438 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref439 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref440 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M166.6 169.1c0-.5.5-1 1-1a1 1 0 010 2 1 1 0 01-1-1"
});
var _ref441 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M166.6 169.1c0-.5.5-1 1-1a1 1 0 010 2 1 1 0 01-1-1z"
});
var _ref442 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M170 168.5c0-.5.5-1 1.1-1a1 1 0 010 2c-.6 0-1-.4-1-1"
});
var _ref443 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M170 168.5c0-.5.5-1 1.1-1a1 1 0 010 2c-.6 0-1-.4-1-1z"
});
var _ref444 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref445 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref446 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1"
});
var _ref447 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 01-1.1-1z"
});
var _ref448 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 01-1-1"
});
var _ref449 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 01-1-1z"
});
var _ref450 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M178.2 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1m-.7 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 01-1-1m-.2 3c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1m.9 2.8c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 01-1.1-1m1.8 2.6c0-.5.5-1 1-1a1 1 0 010 2 1 1 0 01-1-1"
});
var _ref451 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M182.3 166.5c0-.5.5-1 1-1a1 1 0 010 2 1 1 0 01-1-1"
});
var _ref452 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M182.3 166.5c0-.5.5-1 1-1a1 1 0 010 2 1 1 0 01-1-1z"
});
var _ref453 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1"
});
var _ref454 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref455 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1"
});
var _ref456 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1z"
});
var _ref457 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref458 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref459 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 01-1-1"
});
var _ref460 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref461 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref462 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref463 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1"
});
var _ref464 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 01-1-1z"
});
var _ref465 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M174.7 228.9h-1v-1h-1.5v3.6h1.6v2.5h-3.4v7h1.8v14.3h-3.5v7.3h27.2v-7.3h-3.5V241h1.8v-7h-3.4v-2.5h1.6V228h-1.6v.9h-.8v-1h-1.6v1h-1.1v-1h-1.6v3.6h1.6v2.5H184v-7.8h1.7v-3.5H184v.9h-1v-1h-1.5v1h-.9v-1H179v3.6h1.7v7.8h-3.3v-2.5h1.6V228h-1.6v.9h-.9v-1h-1.8v1zm-6 33.7H196m-27.3-1.8H196m-27.3-1.8H196m-27.3-1.7H196m-27.3-2H196m-23.8-1.6h20.2m-20.2-1.8h20.2m-20.2-2h20.2m-20.2-1.7h20.2m-20.2-1.8h20.2m-20.2-1.8h20.2m-20.2-1.7h20.2m-22-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-20.4-1.7h17m-10.2-1.8h3.4m-3.4-1.8h3.4m-3.4-1.8h3.4m-3.4-1.7h3.4m-5.1-2.2h6.8m-12 7.5h3.6m-5-2.2h6.6m-6.7 32.6v-1.8m0-1.8v-1.7m-1.8 1.7v1.8m3.4 0V259m1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m-1.7 7.4v-2m-3.4 2v-2m7 0v2m1.5-2v-1.6m-5.1-1.8v1.8m3.5-1.8v1.8m3.3-1.8v1.8M179 252v-2m1.7-1.7v1.7m0-5.3v1.8m-1.7-3.6v1.8m1.7-3.5v1.7m-3.3-1.7v1.7m-3.5-1.7v1.7m-1.6-3.5v1.8m3.3-1.8v1.8m3.4-1.8v1.8m1.7-3.6v1.8m-3.3-1.8v1.8m-3.5-1.8v1.8m-1.6-3.6v1.8m6.7-1.8v1.8m-3.4-5.3v1.8m15.3-1.8h-3.5m5-2.2h-6.6m6.7 32.6v-1.8m0-1.8v-1.7m1.8 1.7v1.8m-3.4 0V259m-1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m1.7 7.4v-2m3.4 2v-2m-7 0v2m-1.5-2v-1.6m5.1-1.8v1.8m-3.5-1.8v1.8m-3.3-1.8v1.8m1.7-1.8v-2m-1.7-1.7v1.7m0-5.3v1.8m1.7-3.6v1.8m-1.7-3.5v1.7m3.3-1.7v1.7m3.5-1.7v1.7m1.6-3.5v1.8m-3.3-1.8v1.8m-3.4-1.8v1.8m-1.7-3.6v1.8m3.3-1.8v1.8m3.5-1.8v1.8m1.6-3.6v1.8m-6.7-1.8v1.8m3.4-5.3v1.8m-7 18v-2m0-5.4v-1.8m0 5.4v-1.8m0-5.3v-1.8m0-1.8v-1.7m0-3.6v-1.8m0-1.7v-1.8m-8.3 4.6h3.5m3.3-5.3h3.4m3.3 5.3h3.5"
});
var _ref466 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M186.8 262.6v-4.7c0-.8-.4-3.5-4.6-3.5-4 0-4.4 2.7-4.4 3.5v4.7h9z"
});
var _ref467 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  stroke: "#000",
  strokeWidth: 0.4,
  d: "M179.3 258.2l-2.2-.3c0-.9.2-2.2.9-2.6l2 1.5c-.3.2-.7 1-.7 1.4zm6 0l2.2-.3c0-.9-.2-2.2-.9-2.6l-2 1.5c.3.2.7 1 .7 1.4zm-2.2-2.3l1-2a5.3 5.3 0 00-2-.4l-1.7.4 1.1 2h1.6zm-4.2-5.5v-4.9c0-1.3-1-2.4-2.5-2.4s-2.4 1-2.4 2.4v4.9h4.9zm6.8 0v-4.9c0-1.3 1-2.4 2.5-2.4s2.4 1 2.4 2.4v4.9h-4.9zm-1.7-12l.4-4.4h-4.2l.2 4.4h3.6zm3.3 0l-.4-4.4h4.4l-.5 4.4h-3.5zm-10 0l.2-4.4h-4.2l.5 4.4h3.5z"
});
var _ref468 = /*#__PURE__*/React.createElement("path", {
  fill: "#0039f0",
  d: "M185.3 262.6v-4c0-.7-.5-2.7-3.1-2.7-2.4 0-2.9 2-2.9 2.7v4h6zm-6.9-12.7v-4.2c0-1-.6-2.2-2-2.2s-2 1.1-2 2.2v4.3h4zm7.8 0v-4.2c0-1 .7-2.2 2-2.2s2 1.1 2 2.2v4.3h-4z"
});
var _ref469 = /*#__PURE__*/React.createElement("path", {
  fill: "#ad1519",
  d: "M190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5"
});
var _ref470 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.6,
  d: "M190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5z"
});
var _ref471 = /*#__PURE__*/React.createElement("path", {
  fill: "#005bbf",
  d: "M195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13"
});
var _ref472 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.6,
  d: "M195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13z"
});
var _ref473 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 00.6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 010 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 010-.3 1 1 0 011-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 00-1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
});
var _ref474 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.3,
  d: "M201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 00.6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 010 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 010-.3 1 1 0 011-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 00-1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
});
var _ref475 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M199.2 269.9h4.1v-1h-4.1v1z"
});
var _ref476 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M199.2 269.9h4.1v-1h-4.1v1z"
});
var _ref477 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M211.4 260.9s-1.3 1.4-1.3 2.7c0 1.3.6 2.4.6 2.4-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 011 1 .9.9 0 010 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 010-.3 1 1 0 011-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 00-1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
});
var _ref478 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.3,
  d: "M211.4 260.9s-1.3 1.4-1.3 2.7c0 1.3.6 2.4.6 2.4-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 011 1 .9.9 0 010 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 010-.3 1 1 0 011-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 00-1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
});
var _ref479 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M209.4 269.9h4.1v-1h-4.1v1z"
});
var _ref480 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M209.4 269.9h4.1v-1h-4.1v1z"
});
var _ref481 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 011 1 .9.9 0 010 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 010-.3 1 1 0 011-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 00-1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
});
var _ref482 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 0.3,
  d: "M206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 011 1 .9.9 0 010 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 010-.3 1 1 0 011-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 00-1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
});
var _ref483 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M204.3 278.6h4.1v-1h-4.1v1z"
});
var _ref484 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M204.3 278.6h4.1v-1h-4.1v1z"
});
var _ref485 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M237.6 223.4h-.3a1.5 1.5 0 01-.3.4c-.2.2-.6.2-.8 0a.5.5 0 01-.1-.4.5.5 0 01-.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 010-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 012.9 1.6 9 9 0 012.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 01-.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 01-.1-.4.6.6 0 01-.5 0c-.2-.2-.3-.5 0-.8l.2-.3v-.3"
});
var _ref486 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M237.6 223.4h-.3a1.5 1.5 0 01-.3.4c-.2.2-.6.2-.8 0a.5.5 0 01-.1-.4.5.5 0 01-.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 010-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 012.9 1.6 9 9 0 012.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 01-.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 01-.1-.4.6.6 0 01-.5 0c-.2-.2-.3-.5 0-.8l.2-.3v-.3z"
});
var _ref487 = /*#__PURE__*/React.createElement("path", {
  d: "M235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2"
});
var _ref488 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2z"
});
var _ref489 = /*#__PURE__*/React.createElement("path", {
  d: "M236.3 224.8l-.3-.2v-.2h.1l.4.3.3.2v.2h-.2l-.3-.3"
});
var _ref490 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M236.3 224.8l-.3-.2v-.2h.1l.4.3.3.2v.2h-.2l-.3-.3"
});
var _ref491 = /*#__PURE__*/React.createElement("path", {
  d: "M234.6 223.7l-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1l-.3-.1"
});
var _ref492 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M234.6 223.7l-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1l-.3-.1"
});
var _ref493 = /*#__PURE__*/React.createElement("path", {
  d: "M233.7 223h.2v.2h-.2s-.1-.1 0-.2"
});
var _ref494 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M233.7 223h.2v.2h-.2s-.1-.1 0-.2z"
});
var _ref495 = /*#__PURE__*/React.createElement("path", {
  d: "M237.3 225.5v-.2h-.3l.1.2h.2"
});
var _ref496 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M237.3 225.5v-.2h-.3l.1.2h.2z"
});
var _ref497 = /*#__PURE__*/React.createElement("path", {
  d: "M237.9 226.2l.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2l.2.2"
});
var _ref498 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M237.9 226.2l.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2l.2.2"
});
var _ref499 = /*#__PURE__*/React.createElement("path", {
  d: "M238.8 227v-.3h-.3v.2h.3"
});
var _ref500 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M238.8 227v-.3h-.3v.2h.3z"
});
var _ref501 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5"
});
var _ref502 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5"
});
var _ref503 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M234.6 221.6v.5l.9.1h.1v-.2l-.5-.7-.5.3"
});
var _ref504 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M234.6 221.6v.5l.9.1h.1v-.2l-.5-.7-.5.3"
});
var _ref505 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M236.4 222.6l-.4.3-.6-.7v-.1h1.1v.5"
});
var _ref506 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M236.4 222.6l-.4.3-.6-.7v-.1h1.1v.5"
});
var _ref507 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M235.3 222a.3.3 0 01.4 0 .3.3 0 010 .3.3.3 0 01-.3 0 .3.3 0 01-.1-.3"
});
var _ref508 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M235.3 222a.3.3 0 01.4 0 .3.3 0 010 .3.3.3 0 01-.3 0 .3.3 0 01-.1-.3z"
});
var _ref509 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M233.2 221.1l-.2-.7-.4-.4s.4-.2.8.1c.4.3 0 .9 0 .9l-.2.1"
});
var _ref510 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M233.2 221.1l-.2-.7-.4-.4s.4-.2.8.1c.4.3 0 .9 0 .9l-.2.1z"
});
var _ref511 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M234.2 221.4l-.4.4-.6-.6v-.2h1v.4"
});
var _ref512 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M234.2 221.4l-.4.4-.6-.6v-.2h1v.4"
});
var _ref513 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M233.1 221l.3-.1v.3c0 .2-.1.2-.2.2l-.1-.3"
});
var _ref514 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M233.1 221l.3-.1v.3c0 .2-.1.2-.2.2l-.1-.3z"
});
var _ref515 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M238.3 222.5h-.5l-.3.7v.2h.2l.8-.4-.2-.5"
});
var _ref516 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M238.3 222.5h-.5l-.3.7v.2h.2l.8-.4-.2-.5"
});
var _ref517 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M236.7 222.8v.5l.8.2h.1v-.2l-.4-.7-.5.2"
});
var _ref518 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M236.7 222.8v.5l.8.2h.1v-.2l-.4-.7-.5.2"
});
var _ref519 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M238.4 224l-.5.2-.4-.7v-.2h.1l.9.2-.1.5"
});
var _ref520 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M238.4 224l-.5.2-.4-.7v-.2h.1l.9.2-.1.5"
});
var _ref521 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M237.3 223.2h.4a.3.3 0 010 .4.3.3 0 01-.3 0 .3.3 0 010-.4"
});
var _ref522 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M237.3 223.2h.4a.3.3 0 010 .4.3.3 0 01-.3 0 .3.3 0 010-.4z"
});
var _ref523 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M240.2 224.3l.1.5-.8.3h-.2v-.2l.4-.8.5.2"
});
var _ref524 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M240.2 224.3l.1.5-.8.3h-.2v-.2l.4-.8.5.2"
});
var _ref525 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M240 225.8l-.5.1-.3-.8v-.1h.2l.8.3-.1.5"
});
var _ref526 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M240 225.8l-.5.1-.3-.8v-.1h.2l.8.3-.1.5"
});
var _ref527 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M238.6 224.3l-.2.5.9.3h.1v-.1l-.3-.8-.5.1"
});
var _ref528 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M238.6 224.3l-.2.5.9.3h.1v-.1l-.3-.8-.5.1"
});
var _ref529 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M239.5 225.2a.3.3 0 000-.3.3.3 0 00-.4 0 .3.3 0 000 .3.3.3 0 00.4 0"
});
var _ref530 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M239.5 225.2a.3.3 0 000-.3.3.3 0 00-.4 0 .3.3 0 000 .3.3.3 0 00.4 0z"
});
var _ref531 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2l-.2.2"
});
var _ref532 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2l-.2.2z"
});
var _ref533 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M240.3 226.1l-.3.5.8.5v-.1h.2l-.1-1-.6.1"
});
var _ref534 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M240.3 226.1l-.3.5.8.5v-.1h.2l-.1-1-.6.1"
});
var _ref535 = /*#__PURE__*/React.createElement("path", {
  fill: "#c8b100",
  d: "M241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2h.3"
});
var _ref536 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.3,
  d: "M241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2h.3zm38-21.9v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1"
});
var _ref537 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0,
  d: "M134.4 217.1v-1.2m-.4 1.2v-1.2m-.2 1.2v-1.2m-.3 1.2v-1.2"
});
var _ref538 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M133.2 217.1v-1.2m-.5 1.1v-1m.2 1v-1m-.7 1v-1m.2 1v-1m-.9 1v-1m.2 1v-1m.3 1v-1m-.7 1v-1m-.3.9v-.8m-.1.8v-.8m-.5.7v-.6m.2.6v-.6m-.4.5v-.5m-.2.5v-.4m-.3.3v-.3m-.3.3v-.2"
});
var _ref539 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.2,
  d: "M129.2 216.6v-.2"
});
var _ref540 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0,
  d: "M135.7 217v-1m-.5 1v-1m-.4 1.2V216m143 1.1V216m-.4 1.1V216m-.3 1.1V216m-.3 1.2V216"
});
var _ref541 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.1,
  d: "M276.6 217.1V216m-.6 1v-1m.3 1v-1m-.8 1v-1m.3 1v-1m-.9 1v-1m.2 1v-1m.2 1v-1m-.6 1v-1m-.3.9v-.8m-.2.8v-.8m-.4.7v-.6m.2.6v-.6m-.5.6v-.6m-.2.5v-.4m-.3.4v-.4m-.2.3v-.2"
});
var _ref542 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0.2,
  d: "M272.6 216.6v-.2"
});
var _ref543 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 0,
  d: "M279.1 217v-1m-.6 1v-1m-.4 1.1V216"
});
function SvgSpainFlags(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icon-css-es",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371, _ref372, _ref373, _ref374, _ref375, _ref376, _ref377, _ref378, _ref379, _ref380, _ref381, _ref382, _ref383, _ref384, _ref385, _ref386, _ref387, _ref388, _ref389, _ref390, _ref391, _ref392, _ref393, _ref394, _ref395, _ref396, _ref397, _ref398, _ref399, _ref400, _ref401, _ref402, _ref403, _ref404, _ref405, _ref406, _ref407, _ref408, _ref409, _ref410, _ref411, _ref412, _ref413, _ref414, _ref415, _ref416, _ref417, _ref418, _ref419, _ref420, _ref421, _ref422, _ref423, _ref424, _ref425, _ref426, _ref427, _ref428, _ref429, _ref430, _ref431, _ref432, _ref433, _ref434, _ref435, _ref436, _ref437, _ref438, _ref439, _ref440, _ref441, _ref442, _ref443, _ref444, _ref445, _ref446, _ref447, _ref448, _ref449, _ref450, _ref451, _ref452, _ref453, _ref454, _ref455, _ref456, _ref457, _ref458, _ref459, _ref460, _ref461, _ref462, _ref463, _ref464, _ref465, _ref466, _ref467, _ref468, _ref469, _ref470, _ref471, _ref472, _ref473, _ref474, _ref475, _ref476, _ref477, _ref478, _ref479, _ref480, _ref481, _ref482, _ref483, _ref484, _ref485, _ref486, _ref487, _ref488, _ref489, _ref490, _ref491, _ref492, _ref493, _ref494, _ref495, _ref496, _ref497, _ref498, _ref499, _ref500, _ref501, _ref502, _ref503, _ref504, _ref505, _ref506, _ref507, _ref508, _ref509, _ref510, _ref511, _ref512, _ref513, _ref514, _ref515, _ref516, _ref517, _ref518, _ref519, _ref520, _ref521, _ref522, _ref523, _ref524, _ref525, _ref526, _ref527, _ref528, _ref529, _ref530, _ref531, _ref532, _ref533, _ref534, _ref535, _ref536, _ref537, _ref538, _ref539, _ref540, _ref541, _ref542, _ref543);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpainFlags);
export default __webpack_public_path__ + "static/media/spain_flags.1a25a96e26fcca676c08fb109bcec333.svg";
export { ForwardRef as ReactComponent };